import CreateAssetPackModal from './CreateAssetPackModal.container'

export default CreateAssetPackModal
